export default {
  ALFALFA: 'Alfalfa',
  ALMOND: 'Almond',
  APPLE: 'Apple',
  AVOCADO: 'Avocado',
  BANANA: 'Banana',
  BARLEY: 'Barley',
  BASIL: 'Basil',
  CABBAGE: 'Cabbage',
  CANOLA: 'Canola',
  CASSAVA: 'Cassava',
  CAULIFLOWER: 'Cauliflower',
  CITRUS: 'Citrus',
  CLOVER: 'Clover',
  CORN: 'Corn',
  CORN_GRAIN: 'Corn Grain',
  CORN_SILAGE: 'Corn Silage',
  COTTON: 'Cotton',
  DURUM_WHEAT: 'Durum Wheat',
  GRAPE: 'Grape',
  LETTUCE: 'Lettuce',
  MILO: 'Milo',
  OIL_PALM: 'Oil Palm',
  PEANUT: 'Peanut',
  PECAN: 'Pecan',
  POTATO: 'Potato',
  RICE: 'Rice',
  RIVER_BIRCH: 'River Birch',
  SORGHUM: 'Sorghum',
  SOYBEAN: 'Soybean',
  SPRING_WHEAT: 'Spring Wheat',
  SUGARBEET: 'Sugarbeet',
  SUGARCANE: 'Sugarcane',
  SUNFLOWER: 'Sunflower',
  SWEET_POTATO: 'Sweet Potato',
  TOMATO: 'Tomato',
  VEGETABLES: 'Vegetables',
  WHEAT: 'Wheat',
  WINTER_WHEAT: 'Winter Wheat',
  ONION: 'Onion'
};